// import { useEffect } from "react";
// import { GetCustomerDetail } from "../../../services/modules/verify";
// import { MARITAL_STATUS_TRANSLATIONS } from "../../../constants/form-profile";

// export function useSyncFormProfile({
//   loadingStateSetter,
//   userDataSetter,
//   formInitialValuesSetter,
// }) {
//   useEffect(() => {

//     const savedIdCard = localStorage.getItem("idCard");
//     const savedDob = localStorage.getItem("dob");

//     if (savedIdCard && savedDob) {
//       const data = {
//         id_card: savedIdCard,
//         date_of_birth: savedDob,
//       };

//       loadingStateSetter((_) => true);

//       GetCustomerDetail({ body: data })
//         .then((response) => {
//           const customerDetail = response.resultData[0];

//           console.log("customerDetail", customerDetail);

//           userDataSetter((_) => customerDetail);

//           loadingStateSetter((_) => false);

//           formInitialValuesSetter((_) => ({
//             ...customerDetail,
//             dob: customerDetail.date_of_birth,
//             currentAddress: customerDetail.address,
//             currentProvince: customerDetail.province,
//             currentDistrict: customerDetail.district,
//             currentSubDistrict: customerDetail.sub_district,
//             currentPostalCode: customerDetail.zip,
//             status: MARITAL_STATUS_TRANSLATIONS[customerDetail.status], // Translate from English to Thai
//           }));
//         })
//         .catch((err) => console.error("Error fetching user data:", err));
//     } else {
//       console.error("Missing credentials");
//       loadingStateSetter((_) => false);
//     }
//   }, []);
// }
import { useEffect } from "react";
import { GetCustomerDetail } from "../../../services/modules/verify";
import { normalizeMaritalStatus } from "../../../constants/form-profile";
import { useTranslation } from "react-i18next";
import provinceJson from "../../../pages/Json/allprovince.json";

export function useSyncFormProfile({
  loadingStateSetter,
  userDataSetter,
  formInitialValuesSetter,
}) {
  const { i18n } = useTranslation();
  const lang = i18n.language.startsWith("en") ? "en" : "th";

  useEffect(() => {
    const savedIdCard = localStorage.getItem("idCard");
    const savedDob = localStorage.getItem("dob");

    if (savedIdCard && savedDob) {
      const data = {
        id_card: savedIdCard,
        date_of_birth: savedDob,
      };

      loadingStateSetter(true);

      GetCustomerDetail({ body: data })
        .then((response) => {
          const customerDetail = response.resultData[0];
          userDataSetter(customerDetail);
          console.log("customerDetail", customerDetail);
          const province = provinceJson.find(
            (p) => p.name_th === customerDetail.province
          );
          const district = province?.amphure.find(
            (d) => d.name_th === customerDetail.district
          );
          const subDistrict = district?.tambon.find(
            (s) => s.name_th === customerDetail.sub_district
          );

          const getName = (item) =>
            lang === "en" ? item?.name_en || "" : item?.name_th || "";

          formInitialValuesSetter((prev) => ({
            ...prev,
            ...customerDetail,
            dob: customerDetail.date_of_birth,
            currentAddress: customerDetail.address,
            title: translateTitle(customerDetail.title, lang),
            currentProvince: getName(province),
            currentDistrict: getName(district),
            currentSubDistrict: getName(subDistrict),
            currentPostalCode: customerDetail.zip,
          }));

          loadingStateSetter(false);
        })
        .catch((err) => {
          console.error("Error fetching user data:", err);
          loadingStateSetter(false);
        });
    } else {
      console.error("Missing credentials");
      loadingStateSetter(false);
    }
  }, [i18n.language]); // ✅ re-run when language changes
}

function translateTitle(title, lang) {
  const map = {
    นาย: "Mr.",
    นาง: "Mrs.",
    นางสาว: "Miss",
  };
  if (lang === "en") return map[title] || title;
  const reverse = {
    "Mr.": "นาย",
    "Mrs.": "นาง",
    Miss: "นางสาว",
  };
  return reverse[title] || title;
}
